import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Pagination,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FetchHook from "../../../../Api/FetchHooks";
import {
  formatCurrencyV2,
  formatDate,
  getKycChip,
} from "../../../../utils/helpers";

import AlertComponent from "../../../../Components/AlertComponent";
import Page from "../../../../Components/Page";
import ActionDialog from "../../../../Components/ActionDialog";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import TableComponent from "../../../../Components/TableComponent";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import UseServerTable from "../../../../Hooks/UseServerTable";

const InfoRow = ({ label, value }) => (
  <Box
    display="flex"
    justifyContent="space-between"
    // alignItems={"end"}
    py={0.5}
  >
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body2" color="text.secondary">
      {value}
    </Typography>
  </Box>
);

const UserLoans = ({ fetchUser, showHeader = true }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(location.state?.user || LoggedInUser);
  const [userLoans, setUserLoans] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState();
  const [status, setStatus] = useState("");
  const [viewMode, setViewMode] = useState("cards");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(3);
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchData = useCallback(async () => {
  //   if (status != null && status != "") {
  //     await request({
  //       url: `/loan?status=${status}&entity_id='${user.id}'`,
  //     });
  //   } else {
  //     request({
  //       url: `loan?entity_id='${user.id}'`,
  //     });
  //   }
  // }, [user, status]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0)
  //     setUserLoans(response.data.Loan);
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/loan?status=${status}&entity_id='${user.id}'`,
    onSuccess: (data) => {
      setUserLoans(data.Loan);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "Loan Id",
      width: 180,
    },
    // {
    //   field: "entity_id",
    //   headerName: "Entity Id",
    //   width: 150,
    // },
    // {
    //   field: "product_id",
    //   headerName: "Product Id",
    //   width: 150,
    // },
    // {
    //   field: "supplier_id",
    //   headerName: "Supplier Id",
    //   width: 150,
    // },
    // {
    //   field: "request_id",
    //   headerName: "Request Id",
    //   width: 200,
    // },
    {
      field: "loan_name",
      headerName: "Loan Name",
      width: 150,
    },
    // {
    //   field: "initial_payment",
    //   headerName: "Initial payment",
    //   width: 150,
    // },
    {
      field: "loan_principal",
      headerName: "Loan Amount",
    },
    {
      field: "amount_disburse",
      headerName: "Amount disbursed",
    },
    // {
    //   field: "repayment_count",
    //   headerName: "Repayment duration ",
    // },
    // {
    //   field: "charges_payable",
    //   headerName: "Charges",
    //   flex: 1,
    //   minWidth: 150,
    // },
    {
      field: "loan_interest",
      headerName: "Interest charged",
    },
    // {
    //   field: "application_fee_payable",
    //   headerName: "Processing Fee",
    // },
    // {
    //   field: "principal_payable",
    //   headerName: "Principal balance",
    //   flex: 1,
    //   minWidth: 200,
    // },
    // {
    //   field: "insurance_payable",
    //   headerName: "Insurance Balance",
    //   flex: 1,
    //   minWidth: 200,
    // },
    // {
    //   field: "interest_payable",
    //   headerName: "Interest Balance",
    //   width: 200,
    // },
    {
      field: "instalment_payable",
      headerName: "Instalment Balance",
    },
    {
      field: "balance_payable",
      headerName: "Total Balance Payable",
    },
    // {
    //   field: "loan_interest_bal",
    //   headerName: "Loan interest balance",
    //   width: 200,
    // },
    // {
    //   field: "application_instalment_fee_bal",
    //   headerName: "Application instalment fee balance",
    //   width: 150,
    // },
    // {
    //   field: "insurance_amount",
    //   headerName: "Insurance amount",
    //   width: 150,
    // },
    // {
    //   field: "insurance_bal",
    //   headerName: "Insurance balance",
    //   width: 150,
    // },
    // {
    //   field: "insurance_instalment_bal",
    //   headerName: "Insurance instalment balance",
    //   width: 150,
    // },
    // {
    //   field: "other_charges",
    //   headerName: "Other charges",
    //   width: 150,
    // },
    // {
    //   field: "other_charges_bal",
    //   headerName: "Other charges balance",
    //   width: 150,
    // },
    // {
    //   field: "other_instalment_charges_bal",
    //   headerName: "Other instalment charges balance",
    //   width: 150,
    // },

    // {
    //   field: "interest_last_date",
    //   headerName: "Last interest date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "rollover",
    //   headerName: "Rollover",
    //   width: 150,
    // },
    // {
    //   field: "rollover_interest",
    //   headerName: "Rollover interest",
    //   width: 150,
    // },
    // {
    //   field: "rollover_interest_bal",
    //   headerName: "Rollover interest balance",
    //   width: 150,
    // },
    // {
    //   field: "rollover_times",
    //   headerName: "Rollover times",
    //   width: 150,
    // },
    // {
    //   field: "rollover_start_date",
    //   headerName: "Rollover start date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "rollover_end_date",
    //   headerName: "Rollover end date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "rollover_next_date",
    //   headerName: "Rollover next date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "debt_collection",
    //   headerName: "Debt collection",
    //   width: 150,
    // },
    // {
    //   field: "debt_collection_bal",
    //   headerName: "Debt collection balance",
    //   width: 150,
    // },
    // {
    //   field: "debt_collection_start_date",
    //   headerName: "Debt colection start date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "debt_collection_end_date",
    //   headerName: "Debt collection end date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "last_contractual_instal_date",
    //   headerName: "last contractual installment date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "next_contractual_instal_date",
    //   headerName: "Next contractual installment date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "next_actual_instal_date",
    //   headerName: "Next actual installment date",
    //   flex: 1,
    //   minWidth: 240,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   field: "net_actual_instal_date",
    //   headerName: "Net actual installment date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    {
      field: "active_status",
      headerName: "Status",
      renderCell: (params) => getKycChip(params.value),
    },
    {
      field: "next_contractual_instal_date",
      headerName: "Next Repayment Date",
      width: 150,
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY"),
    },
    {
      field: "loan_start_date",
      headerName: "Loan start date",
      width: 150,
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY"),
    },
    // {
    //   field: "loan_end_date",
    //   headerName: "Loan end date",
    //   width: 150,
    //   valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY"),
    // },
    // {
    //   field: "start_date",
    //   headerName: "Start date",
    //   width: 150,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY"),
    // },
    // {
    //   field: "end_date",
    //   headerName: "End date",
    //   width: 150,
    //   valueFormatter: (params) => {
    //     if (params?.value) {
    //       moment(params?.value).format("DD/MM/YYYY hh:mm A");
    //     }
    //   },
    // },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   width: 200,
    // },

    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   minWidth: 180,
    // },
    {
      field: "loan_transactions",
      headerName: "",
      width: 100,
      renderCell: (row) => (
        <Button
          variant="outlined"
          onClick={() =>
            navigate("/dashboard/user/user-loans/loan-profile", {
              state: { user, loan: row.row },
            })
          }
        >
          Profile
        </Button>
      ),
    },
    {
      field: "repay_loan",
      headerName: "",
      width: 180,
      renderCell: (row) => (
        <Button
          variant="contained"
          onClick={() => {
            openDialog("repay_loan", "Repay loan");
            setSelectedLoan(row.row);
          }}
        >
          Repay Loan
        </Button>
      ),
    },
    // {
    //   field: "loan_transactions",
    //   headerName: "Loan transactions",
    //   width: 200,
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       onClick={() =>
    //         navigate("/dashboard/users/user-profile/loan-transactions", {
    //           state: location.state.user,
    //         })
    //       }
    //     >
    //       Loan transactions
    //     </Button>
    //   ),
    // },
    // {
    //   field: "loan_logs",
    //   headerName: "Loan logs",
    //   width: 200,
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       onClick={() =>
    //         navigate("/dashboard/users/user-profile/loan-logs", {
    //           state: row.row,
    //         })
    //       }
    //     >
    //       Loan logs
    //     </Button>
    //   ),
    // },
    // {
    //   field: "loan_instalment",
    //   headerName: "Loan instalment",
    //   width: 200,
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       onClick={() =>
    //         navigate("/dashboard/users/user-profile/loan-instalments", {
    //           state: row.row,
    //         })
    //       }
    //     >
    //       Loan instalments
    //     </Button>
    //   ),
    // },
  ];

  return (
    <Page
      showHeader={showHeader}
      title={"User Loans"}
      actions={
        <>
          {LoggedInUser.role === "customer" && (
            <Box display={"flex"}>
              <Button
                variant="contained"
                onClick={() =>
                  openDialog("apply_loan", "Loan Application Form")
                }
              >
                Apply loan
              </Button>
            </Box>
          )}
        </>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        data={selectedLoan}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">User Loans</Typography>
              )}
            </>
          }
          action={
            <>
              {showHeader === false && LoggedInUser.role === "customer" && (
                <Box display={"flex"}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      openDialog("apply_loan", "Loan Application Form")
                    }
                  >
                    Apply loan
                  </Button>
                </Box>
              )}
            </>
          }
        />

        <Grid
          pl={2}
          pb={3}
          container
          display={"flex"}
          justifyContent={"space-between"}
          alignItems="center"
        >
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newView) => {
              if (newView !== null) {
                setViewMode(newView);
              }
            }}
            aria-label="view mode"
            size="small"
          >
            <ToggleButton value="cards" aria-label="cards view">
              <ViewModuleIcon />
            </ToggleButton>
            <ToggleButton value="table" aria-label="table view">
              <ViewListIcon />
            </ToggleButton>
          </ToggleButtonGroup>

          <FormControl sx={{ width: "200px" }}>
            <InputLabel id="status" size="small">
              Status
            </InputLabel>

            <Select
              labelId="status"
              id="status"
              value={status}
              label="status"
              onChange={(e) => {
                setStatus(e.target.value);
              }}
              size="small"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
              <MenuItem value="domant">Dormant</MenuItem>
              <MenuItem value="suspended">Suspended</MenuItem>
              <MenuItem value="closed">Closed</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="incomplete">Incomplete</MenuItem>
              <MenuItem value="complete">Complete</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {userLoans && userLoans.length <= 0 && gridProps.loading ? (
          <Grid display={"flex"} justifyContent={"center"}>
            <CircularProgress />
          </Grid>
        ) : userLoans && userLoans.length > 0 ? (
          <Grid container spacing={2}>
            {viewMode === "table" ? (
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <TableComponent
                      data={userLoans}
                      columns={columns}
                      sortModel={[
                        {
                          field: "loan_start_date",
                          sort: "desc",
                        },
                      ]}
                      {...gridProps}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              <>
                {[...userLoans]
                  .sort((a, b) => {
                    const priorityStatus = ["active", "incomplete"];
                    const aIsPriority = priorityStatus.includes(
                      a.active_status,
                    );
                    const bIsPriority = priorityStatus.includes(
                      b.active_status,
                    );

                    if (aIsPriority && !bIsPriority) return -1;
                    if (!aIsPriority && bIsPriority) return 1;

                    return b.id - a.id;
                  })
                  .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                  .map((loan, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                      <Card
                        sx={{
                          mb: 2,
                          borderRadius: 3,
                          boxShadow: 3,
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            boxShadow: 6,
                          },
                        }}
                      >
                        <CardHeader
                          title={
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <CreditCardIcon color="primary" />
                                <Typography
                                  variant="subtitle1"
                                  textTransform="capitalize"
                                >
                                  {loan.loan_name} Loan
                                </Typography>
                              </Box>
                              {getKycChip(loan.active_status)}
                            </Box>
                          }
                          subheader={
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                // gap: 1,
                              }}
                            >
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Loan ID: {loan.id}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Start date: {formatDate(loan.start_date)}
                              </Typography>
                            </Box>
                          }
                        />

                        <CardContent>
                          <InfoRow
                            label="Total Loan Amount"
                            value={formatCurrencyV2(loan.loan_principal)}
                          />
                          <InfoRow
                            label="Balance"
                            value={formatCurrencyV2(loan.balance_payable)}
                          />
                          <InfoRow
                            label="Next Instalment Amount"
                            value={formatCurrencyV2(loan.instalment_payable)}
                          />
                          <InfoRow
                            label="Next Payment Date"
                            value={formatDate(
                              loan.next_contractual_instal_date,
                            )}
                          />
                        </CardContent>

                        <Divider />

                        <CardActions
                          sx={{
                            justifyContent: "end",
                          }}
                        >
                          <Button
                            variant="text"
                            onClick={() =>
                              navigate(
                                "/dashboard/users/user-profile/loan-profile",
                                {
                                  state: { user, loan },
                                },
                              )
                            }
                          >
                            View Profile
                          </Button>
                          {loan.active_status != "closed" && (
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                openDialog("repay_loan", "Repay loan");
                                setSelectedLoan(loan);
                              }}
                            >
                              Repay Loan
                            </Button>
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="center"
                  mt={2}
                >
                  <Pagination
                    count={Math.ceil(userLoans.length / rowsPerPage)}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    color="primary"
                  />
                </Grid>
              </>
            )}
          </Grid>
        ) : (
          (!userLoans || userLoans.length === 0) && (
            <Box sx={{ p: { xs: 2, md: 4 } }}>
              <ErrorDisplay
                message="No Active Loans Found"
                details="Please apply for a loan."
                icon={
                  <AllInboxIcon
                    color="secondary"
                    sx={{ mx: "auto", fontSize: 80 }}
                  />
                }
                actions={
                  <Box display={"flex"}>
                    <Button
                      variant="contained"
                      onClick={() =>
                        openDialog("apply_loan", "Loan Application Form")
                      }
                    >
                      Apply loan
                    </Button>
                  </Box>
                }
              />
            </Box>
          )
        )}
      </Card>

      {/* <Card>
        <CardHeader
          sx={{
            py: "25px",
          }}
          action={
            <Box display={"flex"}>
              <FormControl
                sx={{
                  width: "20vw",
                  mr: "20px",
                }}
              >
                <InputLabel id="status" size="small">
                  Status
                </InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  size="small"
                  defaultValue=""
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                  <MenuItem value="incomplete">Incomplete</MenuItem>
                  <MenuItem value="complete">Complete</MenuItem>
                </Select>
              </FormControl>
            </Box>
          }
        />
        <CardContent>
          {userLoans && userLoans.length > 0 ? (
            <TableComponent
              data={userLoans}
              columns={columns}
              loading={loading}
            />
          ) : loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid
              container
              display={"flex"}
              direction={"column"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AllInboxIcon color="error" sx={{ mx: "auto", fontSize: 80 }} />
              <Typography variant="subtitle1">No recent Loans</Typography>
            </Grid>
          )}
        </CardContent>
      </Card> */}
    </Page>
  );
};

export default UserLoans;
